"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _path = _interopRequireDefault(require("../../../helpers/path"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./PopoverMenu.css");
var _Popover = _interopRequireDefault(require("../Popover/Popover"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PopoverMenu = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function PopoverMenu(props) {
    var _this;
    _classCallCheck(this, PopoverMenu);
    _this = _callSuper(this, PopoverMenu, [props]);
    _defineProperty(_this, "getLinkElement", function (item) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        key: item.label,
        className: _this.baseClasses('item', item.customClass),
        to: (0, _path["default"])(item.linkTo),
        onClick: function onClick() {
          return _this.popoverRef.toggleShow();
        }
      }, item.beforeLabelElement, /*#__PURE__*/_react["default"].createElement("span", {
        className: _this.baseClasses('item-label')
      }, item.label));
    });
    _defineProperty(_this, "getOnClickElement", function (item) {
      return /*#__PURE__*/_react["default"].createElement("a", {
        key: item.label,
        className: _this.baseClasses('item', item.customClass),
        onClick: _this.getOnItemClick(item)
      }, item.beforeLabelElement, /*#__PURE__*/_react["default"].createElement("span", {
        className: _this.baseClasses('item-label')
      }, item.label));
    });
    _defineProperty(_this, "getOnItemClick", function (item) {
      return function () {
        if (typeof item.onClick !== 'undefined') {
          item.onClick();
          _this.popoverRef.toggleShow();
        }
      };
    });
    _defineProperty(_this, "renderContent", function () {
      var items = _this.props.items;
      return items.map(function (item, index) {
        if (item.divider) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: index,
            className: _this.baseClasses('item-divider')
          });
        }
        if (item.linkTo) {
          return _this.getLinkElement(item);
        }
        return _this.getOnClickElement(item);
      });
    });
    _this.popoverRef = null;
    _this.baseClasses = (0, _cssClassesHelper.getBEMClasses)(['popover-menu', _this.props.customClass]);
    return _this;
  }
  _inherits(PopoverMenu, _React$Component);
  return _createClass(PopoverMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var popoverProps = this.props.popoverProps;
      return /*#__PURE__*/_react["default"].createElement(_Popover["default"], _extends({
        ref: function ref(_ref) {
          return _this2.popoverRef = _ref;
        },
        content: /*#__PURE__*/_react["default"].createElement("div", null, this.renderContent()),
        drawArrow: true,
        isMenu: "true",
        customClass: this.baseClasses()
      }, popoverProps));
    }
  }]);
}(_react["default"].Component);
_defineProperty(PopoverMenu, "propTypes", {
  selectedItemLabel: _propTypes["default"].string,
  items: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    beforeLabelElement: _propTypes["default"].element,
    onClick: _propTypes["default"].func,
    linkTo: _propTypes["default"].string,
    customClass: _propTypes["default"].string
  }), _propTypes["default"].shape({
    divider: _propTypes["default"].oneOf([true]).isRequired
  })])).isRequired,
  customClass: _propTypes["default"].string,
  popoverProps: _propTypes["default"].shape({
    trigger: _propTypes["default"].func.isRequired
  }).isRequired
});
_defineProperty(PopoverMenu, "defaultProps", {
  items: [],
  customClass: ''
});